<template>  
  <div class="merchantctrl">

    <el-select v-if='isBatch' filterable :size="slsize" v-model="slvl" multiple clearable style="width: 100%;" :placeholder="$t('app_select')" @change="onChange">
      <el-option
        v-for="(item,index) in tableData"
        :key="index"
        :label="item.productname"
        :value="item.productkey">
      </el-option>
    </el-select>
    <el-select v-else filterable :size="slsize" v-model="slvl"  clearable style="width: 100%;" :placeholder="$t('app_select')" @change="onChange">
      <el-option
        v-for="(item,index) in tableData"
        :key="index"
        :label="item.productname"
        :value="item.productkey">
      </el-option>
    </el-select>
    
  </div>
</template>

<script>
export default {  
  data () {
    return { 
      tableData: [],
      slvl: '',
      slsize: '',
      isBatch: false,
    }
  },
  // value size两个值，callback回调选择的值
  props: ['config'],
  watch: {
    config (n) {
      this.slsize = n.size?n.size:'mini'
      this.slvl = n.value
      this.isBatch = n.isbatch
    }
  },
  methods: {
    onChange (vl) {
      if (this.config.callback) {
        this.config.callback(vl)
      }
    },
    getList () {      
      var mid = ''
      this.$models(1, 99999, mid, res => {        
        if (res.status == 200) { 
          this.tableData = res.data
        }
      }, '')
    }
  },
  mounted () {
    if (this.config) {
      this.slvl = this.config.value?this.config.value:''
      this.slsize = this.config.size?this.config.size:'mini'
      this.isBatch = this.config.isbatch
    }
    this.getList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .merchantctrl {
    width: 100%;
  }
</style>
